import './Expenses.scss';
import Component from './Expenses.js';
export default Component;
